import {createSlice} from '@reduxjs/toolkit'
import {
    ROUTE_PATH
} from "../../app/constants"

const collectorsReviewSlice = createSlice({
    name : "collectorsReview",
    initialState : {
        "collection-agency" : {
            header : "Review your collectors",
            text : ["Check the individual collector licences you want to renew. Licences you don't check will be cancelled at the time this renewal is processed by Business Licensing team."],
            navigation : {
                next : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT
            }
        },
        "debt-management-agency" : {
            header : "Review your debt management agents",
            text : ["Check the individual debt management agent licences you want to renew. Licences you don't check will be cancelled at the time this renewal is processed by Business Licensing team."],
            navigation : {
                next : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT
            }
        }
    }, 
    reducers : {

    }
})

export default collectorsReviewSlice.reducer